// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ehqx","name":"styles_name__1rFVB","phone":"styles_phone__2CxzQ"};